import React, { useState, useEffect } from 'react'
import './InputBox.css';
import YunIcon from '../YunIcon/YunIcon';

const InputBox = function(props) {
    const { val, min, max, step, onChange } = props;
    const [inputValue, setInputValue] = useState("");
    useEffect(() => {
        setInputValue(val)
    }, [val]);

    const formatDecimal = (num) => {
        const decimalPlaces = (step.toString().split('.')[1] || '').length;
        const formattedNumber = parseFloat(num).toFixed(decimalPlaces);        
        const v = parseFloat(formattedNumber);
        return isNaN(v) ? 0 : v;
    }
    const clickSubValue = () => {
        const v = formatDecimal(val - step);
        if (v < min) {
            return
        }
        onChange(v)
    }
    const clickAddValue = () => {
        const v = formatDecimal(val + step);
        if (v > max) {
            return
        }
        onChange(v)
    }
    const blurInput = () => {
        let v = formatDecimal(inputValue)
        if (v > max) v = max;
        if (v < min) v = min;
        onChange(v)
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            blurInput()
        }
    };
    const inputChangeValue = (e) => {
        setInputValue(e.target.value)
    }
    return (
        <div className="InputBox">
            <div className="InputBoxBtn">
                <YunIcon onClick={clickSubValue} icon="icon_sub"></YunIcon>
            </div>
            <input value={inputValue} onChange={inputChangeValue} onKeyDown={handleKeyPress} onBlur={blurInput} className="InputBoxInput" />
            <div className="InputBoxBtn">
                <YunIcon onClick={clickAddValue} icon="icon_add"></YunIcon>
            </div>
        </div>
    )
}

export default InputBox;
